import { brandConfiguration } from "@/brands/config";
import { useContactFormSection } from "@/contexts/contact";
import { useI18n, useIsNewBuildProject } from "@/shared/hooks";
export const useContactButtonLabel = () => {
    const { t } = useI18n();
    const { contactFormSubmitAgency, contactFormSubmitPrivate } = brandConfiguration.lokaliseSpecificKeys;
    const isProject = useIsNewBuildProject();
    const contactFormSection = useContactFormSection();
    const contactFormSubmitBtnText = isProject
        ? t("contact.form.project.email")
        : t(
        // @ts-ignore
        contactFormSection.contactCard.isPrivateOwner
            ? contactFormSubmitPrivate
            : contactFormSubmitAgency);
    return contactFormSubmitBtnText;
};
